import React, { Component } from 'react';
import { Modal, ModalBody } from 'reactstrap';
import InputField from '../../../components/inputs/inputField';
import ViewsTable from '../../../components/tables/ViewsTable';

class DuplicateProposalRequestModal extends Component {
	constructor(props) {
		super(props);
		this.state = {
			currentSection: 0,
			sectionCount: 2,
			searchTerm: '',
			checkedRequest: {},
			chosenRequest: null,
			nextSectionEnabled: false,
			newName: '',
			submitting: false,
			submitError: '',
			requiredFields: {
				newName: false,
			},
		};
	}

	selectRequest = (requestId) => {
		let checked = {};
		if (this.state.checkedRequest[requestId]) {
			checked = {};
		} else {
			checked[requestId] = true;
		}
		const chosenRequest = checked[requestId]
			? this.props.requests.find((r) => r._id === requestId)
			: null;
		this.setState({
			checkedRequest: checked,
			chosenRequest,
			nextSectionEnabled: !!Object.keys(checked).length,
		});
	};

	nextSection = () => {
		const { chosenRequest, currentSection } = this.state;
		if (currentSection === 0 && chosenRequest) {
			this.setState({
				currentSection: 1,
				newName: `${chosenRequest.name} (Copy)`,
				nextSectionEnabled: true,
			});
		}
	};

	prevSection = () => {
		this.setState({
			currentSection: 0,
			nextSectionEnabled: !!this.state.chosenRequest,
		});
	};

	handleSubmit = async () => {
		const { chosenRequest, newName } = this.state;
		const requiredFields = {
			newName: !newName || newName.trim() === '',
		};
		if (requiredFields.newName) {
			this.setState({ requiredFields });
			return;
		}
		this.setState({ submitting: true, submitError: '' });
		try {
			await this.props.handleSubmit(chosenRequest._id, newName.trim());
		} catch (e) {
			this.setState({ submitting: false, submitError: e?.message || 'An error occurred.' });
		}
	};

	render() {
		const { isOpen, toggle, requests } = this.props;
		const {
			currentSection,
			sectionCount,
			searchTerm,
			checkedRequest,
			nextSectionEnabled,
			newName,
			submitting,
			submitError,
			requiredFields,
			chosenRequest,
		} = this.state;

		const columns = {
			name: 'Request Name',
			eventName: 'Event Name',
			status: 'Status',
			arrivalDate: 'Arrival Date',
		};
		const columnTypes = {
			name: 'string',
			eventName: 'string',
			status: 'string',
			arrivalDate: 'date',
		};
		const columnWidths = { name: 250 };
		const toggledColumns = {};
		const normalizedColumns = Object.keys(columns).map((key) => {
			toggledColumns[key] = true;
			return {
				label: columns[key],
				key,
				value: key,
				type: columnTypes[key],
				sortAsc: false,
				sortDesc: false,
			};
		});

		let tableData = requests || [];
		if (searchTerm.trim().length > 0) {
			const terms = searchTerm.toLowerCase().split(' ').filter(Boolean);
			terms.forEach((term) => {
				tableData = tableData.filter((entry) =>
					Object.keys(columns).some(
						(key) =>
							entry[key] && entry[key].toString().toLowerCase().includes(term)
					)
				);
			});
		}

		return (
			<Modal isOpen={isOpen} toggle={toggle} className="stepSize eventModal">
				<div className="modalHeader">
					<button
						onClick={toggle}
						style={{ position: 'absolute', right: 5, top: 5, padding: 7 }}
					>
						<i className="las la-times" />
					</button>
					<div className="headerContainer" style={{ position: 'relative' }}>
						<p className="grey small mt-10" style={{ position: 'absolute', right: 0 }}>
							Step {currentSection + 1} of {sectionCount}
						</p>
					</div>
				</div>

				<ModalBody className="modalBody">
					{/* ── Step 0: Choose a request ── */}
					<div
						className={`sectionBody w-100 posAbs anim left ${
							currentSection === 0 ? '' : 'closed'
						}`}
					>
						<div style={{ textAlign: 'center' }}>
							<h1>Duplicate Proposal Request</h1>
							<p className="mb-10 mt-10">
								Choose a proposal request to duplicate.
							</p>
						</div>

						<div className="sectionBlock viewsTable">
							<div className="mb-10 mt-10 flex aic">
								<InputField
									classes="m-0 viewSearch"
									placeholder="Search"
									clickIcon={true}
									required={false}
									value={searchTerm}
									onChange={(e) => {
										this.setState({ searchTerm: e.target.value });
									}}
									prefix={
										<i
											className="las la-search"
											style={{ marginRight: 5, transform: 'rotate(270deg)' }}
										/>
									}
									inputIcon={
										searchTerm !== '' && (
											<i
												onMouseDown={() =>
													this.setState({ searchTerm: '' })
												}
												className="las la-times-circle"
											/>
										)
									}
								/>
							</div>
							<div className="componentList p-0" style={{ height: '500px' }}>
								<ViewsTable
									title="ProposalRequest"
									classes="h-100 mt-10 viewsTableScrollable"
									columns={normalizedColumns}
									toggledColumns={toggledColumns}
									columnWidths={columnWidths}
									data={tableData}
									mainColumnActive={false}
									checked={checkedRequest}
									checkRow={this.selectRequest}
									singleCheck={true}
									mainActions={{}}
									checkAllRows={{}}
									sortData={() => {}}
									disableCheck={false}
								/>
							</div>
						</div>
					</div>

					{/* ── Step 1: New name ── */}
					<div
						className={`sectionBody w-100 posAbs anim right ${
							currentSection === 1 ? '' : 'closed'
						}`}
					>
						<div style={{ textAlign: 'center' }}>
							<h1>New Request Name</h1>
							<p className="mb-10 mt-10">
								Duplicating: <b>{chosenRequest?.name}</b>
							</p>
						</div>
						<div className="flex flex-wrap jcc" style={{ overflowX: 'hidden', maxHeight: 'calc(100% - 96px)' }}>
							<div className="sectionBlock mr-15 mb-15" style={{ maxWidth: 600, paddingLeft: 1, paddingTop: 30 }}>
								<InputField
									label="Request Name"
									required={true}
									errorTrigger={requiredFields.newName}
									errorMessage="Request name is required"
									value={newName}
									onChange={(e) => {
										this.setState({
											newName: e.target.value,
											requiredFields: { ...requiredFields, newName: false },
										});
									}}
								/>
								{submitError && (
									<p className="red small mt-10">{submitError}</p>
								)}
							</div>
						</div>
					</div>
				</ModalBody>

				<div className="flex">
					{currentSection === 0 ? (
						<button className="neu ml-a mr-15" onClick={toggle}>
							Cancel
						</button>
					) : (
						<button
							className={!submitting ? 'neu ml-a mr-15' : 'disabled ml-a mr-15'}
							onClick={this.prevSection}
						>
							{!submitting ? 'Back' : ''}
						</button>
					)}
					{currentSection < sectionCount - 1 ? (
						<button
							className={`neu ${nextSectionEnabled ? 'prim' : 'disabled'}`}
							onClick={this.nextSection}
						>
							Next
						</button>
					) : (
						<button
							className={`neu ${nextSectionEnabled && !submitting ? 'prim' : 'disabled'}`}
							onClick={this.handleSubmit}
						>
							{submitting ? 'Duplicating...' : 'Duplicate Request'}
						</button>
					)}
				</div>
			</Modal>
		);
	}
}

export default DuplicateProposalRequestModal;
